import { render, staticRenderFns } from "./EncounterTemplates.vue?vue&type=template&id=5df567b9&"
import script from "./EncounterTemplates.vue?vue&type=script&lang=js&"
export * from "./EncounterTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EncounterTemplates.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
